// removed by extract-text-webpack-plugin
module.exports = {"contactAddress":"ContactAddress__contactAddress__3Pfwl","appDecorativeLabel":"ContactAddress__appDecorativeLabel__tNZNc","contactInfo":"ContactAddress__contactInfo__2Q8Rn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/ContactAddress/ContactAddress.css
// module id = 307
// module chunks = 0